export var GRID_NOTIFICATION_POSITION;
(function (GRID_NOTIFICATION_POSITION) {
    GRID_NOTIFICATION_POSITION[GRID_NOTIFICATION_POSITION["overlay"] = 0] = "overlay";
    GRID_NOTIFICATION_POSITION[GRID_NOTIFICATION_POSITION["offset"] = 1] = "offset";
})(GRID_NOTIFICATION_POSITION || (GRID_NOTIFICATION_POSITION = {}));
/**
 * Sort directions for `direction` prop in sort config
 */
export var GRID_SORT_DIRECTIONS;
(function (GRID_SORT_DIRECTIONS) {
    GRID_SORT_DIRECTIONS["asc"] = "asc";
    GRID_SORT_DIRECTIONS["desc"] = "desc";
})(GRID_SORT_DIRECTIONS || (GRID_SORT_DIRECTIONS = {}));
/**
 * Grid height mode
 */
export var GRID_HEIGHT_MODE;
(function (GRID_HEIGHT_MODE) {
    GRID_HEIGHT_MODE["auto"] = "auto";
    GRID_HEIGHT_MODE["native"] = "native";
})(GRID_HEIGHT_MODE || (GRID_HEIGHT_MODE = {}));
/**
 * Align text in cell
 */
export var GRID_COLUMN_JUSTIFY;
(function (GRID_COLUMN_JUSTIFY) {
    GRID_COLUMN_JUSTIFY[GRID_COLUMN_JUSTIFY["center"] = 0] = "center";
    GRID_COLUMN_JUSTIFY[GRID_COLUMN_JUSTIFY["left"] = 1] = "left";
    GRID_COLUMN_JUSTIFY[GRID_COLUMN_JUSTIFY["right"] = 2] = "right";
})(GRID_COLUMN_JUSTIFY || (GRID_COLUMN_JUSTIFY = {}));
//# sourceMappingURL=types.js.map